import {all, put, takeLatest} from 'redux-saga/effects';
import request, {GET, PATCH} from '../../services/request';
import * as actionTypes from '../actions/actionTypes';
import {handleError, sleep, ValidationException} from './common';
import {API_URL} from '../../configuration/config';
import {passwordIsValid, emailIsValid, walletIsValid} from '../../services/validation';
import i18n from '../../configuration/i18n';

function *fetchProfile() {
  try {
    const response = yield request(GET, API_URL + 'users/me/');
    yield put({type: actionTypes.PROFILE_FETCH_SUCCESS, payload: response.data});
  } catch (error) {
    yield handleError({error});
    yield put({type: actionTypes.PROFILE_FETCH_FAILED, error});
  }
}

function *changeProfile(action) {
  try {
    let isValid = action.payload.value === action.payload.valueRepeat;
    let validationError = 'errors.validation.valueMatch';
    if (isValid) {
      switch (action.payload.field) {
        case 'email':
          isValid = emailIsValid(action.payload.value);
          validationError = 'errors.validation.email';
          break;
        case 'password':
          isValid = passwordIsValid(action.payload.value);
          validationError = 'errors.validation.password';
          break;
        case 'wallet':
          isValid = walletIsValid(action.payload.value);
          validationError = 'errors.validation.wallet';
          break;
        default:
          break;
      }
    }
    if (!isValid) {
      yield sleep(100);
      throw new ValidationException({
        value: [i18n.t(validationError)],
      });
    }
    const headers = {
      'X-Verification-Code': action.payload.code,
      ...(action.payload.field === 'email' && {'X-Verification-Code-New-Email': action.payload.codeNewEmail}),
    };
    yield request(PATCH, API_URL + 'users/me/', {[action.payload.field]: action.payload.value}, {headers});
    yield put({type: actionTypes.USER_PROFILE_CHANGE_SUCCESS});
    if (action.payload.callback) {
      action.payload.callback();
    }
  } catch (error) {
    yield handleError({error, ignore: [400, 401]});
    yield put({type: actionTypes.USER_PROFILE_CHANGE_FAILED, error});
  }
}

export default function *user() {
  yield all([
    yield takeLatest([actionTypes.PROFILE_FETCH, actionTypes.USER_PROFILE_CHANGE_SUCCESS], fetchProfile),
    yield takeLatest(actionTypes.USER_PROFILE_CHANGE, changeProfile),
  ]);
}



// WEBPACK FOOTER //
// /src/redux/saga/user.js